import '../index.css';
var styles = {
  "root": "bp_radio_group_module_root--bc1a1",
  "horizontal": "bp_radio_group_module_horizontal--bc1a1",
  "radioOption": "bp_radio_group_module_radioOption--bc1a1",
  "label": "bp_radio_group_module_label--bc1a1",
  "description": "bp_radio_group_module_description--bc1a1",
  "disabled": "bp_radio_group_module_disabled--bc1a1",
  "radioButton": "bp_radio_group_module_radioButton--bc1a1",
  "indicator": "bp_radio_group_module_indicator--bc1a1"
};
export { styles as default };